// packages/content/src/tuning/news.ts (M1-T17) — the town news board: how far back it reaches and how many rows a page holds
import type { TuningBank } from '../schema/tuning';
export default { keepDays: 30, pageSize: 20 } as const satisfies TuningBank;
